import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e2333fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-light container-fluid container-lg dropdown-nav-slider shadow-1-strong" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row justify-content-center collapse py-3",
  id: "learn-more"
}, [
  /*#__PURE__*/_createElementVNode("h4", { class: "col-12 col-lg-8 text-center" }, [
    /*#__PURE__*/_createTextVNode(" Learn "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ology.substack.com/p/the-time-has-come",
      target: "_blank"
    }, "more"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ology.substack.com/about",
      target: "_blank"
    }, "subscribe"),
    /*#__PURE__*/_createTextVNode(" for updates. ")
  ])
], -1))
const _hoisted_3 = {
  class: "row justify-content-center collapse py-3",
  id: "search-form"
}
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-block mt-2" }, " Search ", -1))
const _hoisted_7 = { class: "container-fluid container-lg bg-light mt-4" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-12 d-flex align-items-center justify-content-center" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "row justify-content-center align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "col-4 align-items-center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "List:", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "col-4 align-items-center"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-4 align-items-center" }

import { ref, onMounted, watch, Ref } from "vue";
    import { onBeforeRouteLeave } from "vue-router";
    import ArticleThread from "@/components/ArticleThread.vue";
    import { MDBSpinner, MDBBtn, MDBIcon, MDBFooter } from "mdb-vue-ui-kit";
    import * as utility from '@/functions/utility';
    import * as feed from '@/functions/feed';
    import { getAllListGroups, getAllLists, parseListKey } from '@/functions/store';
    import axios from "axios";
    import router from '@/router';
    import { Thread } from '@/types/Thread';

    // define props
    interface Props {
        url: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
    url: null
  },
  setup(__props: any) {

const props = __props as {
        url: string
    }

    

    // setup universal vars
    let updateInterval: any;
    const spinnerMin = 1500;
    const threads: Ref<Thread[]> = ref([]);
    const gettingArticles = ref(false);
    const search_term = ref("");

    // set up spinner visibility and watcher
    const spinnerVisible = ref(false);
    watch(gettingArticles, (gettingArticles) => spinnerVisible.value = gettingArticles);

    const newArticlesAdded = ref(0);

    function search() {
        if (search_term.value.length > 0) {
            router.push({ name: 'Search', params: { param: search_term.value } });
        }
    }

    // setup parent feeds
    let feeds: any = {};
    const feedUrl = ref(props.url || null);
    const feedEditKeyName = localStorage.getItem('feedEditKey');

    /**
    * Get Articles for a given Feed
    *
    * @param currentFeed Current Feed to fetch articles (specified in case it gets changed)
    * @param etag entity tage
    * @param link URL
    * @return array of articles
    */
    async function getArticles(currentFeed: any, etag = '', link: string | null = null) {
        // get articles from url
        const ingestedArticles = [];

        let urlObj = new URL(currentFeed.feedUrl);
        urlObj.searchParams.append('cb', window.location.hostname);

        link = urlObj.href;

        try {
            let config: any = {
                validateStatus: function (status: number) {
                    return status == 200 || status == 304;
                },
                url: link,
            };

            if (etag != '') {
                config.headers = {
                    'If-None-Match': etag
                };
            }

            const response = await axios.request(config);

            if (response.status === 304) {
                return [];
            }

            currentFeed.latestEtag = response.headers.etag || '';
            const articleList = response.data.split("\n");

            for (let i = 0; i < articleList.length; i++) {
                const line = articleList[i];

                if (line !== "") {
                    try {
                        const parsedArticle = JSON.parse(line);
                        let convertedArticle = JSON.parse(JSON.stringify(parsedArticle.metainfo));
                        convertedArticle.feedCopy = JSON.parse(JSON.stringify(parsedArticle));

                        ingestedArticles.push(convertedArticle);
                    } catch (e) {
                        console.log("Skipped invalid line: " + line);
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }

        // filter out articles that have already been displayed
        let newArticles = [];
        for (let j = 0; j < ingestedArticles.length; j++) {
            const article = ingestedArticles[j];

            if (/twitter.com\/.+\/status/.test(article.info.publicSquare.package.canonicalUrl)) {
                article.contentType = 'Tweet';
            }

            if (currentFeed.hashes.includes(article.infoHash) == false) {
                newArticles.push(article);
                // include in allArticles
                currentFeed.allArticles.push(article);
            }
        }

        return newArticles;
    }

    function scrollToTop() {
        window.scrollTo(0, 0);
    }

    /**
    * Add Articles to the current visible feed
    */
    async function addArticles() {
        if (gettingArticles.value) {
            return;
        }

        gettingArticles.value = true;
        const startTime = Date.now();
        console.log(`Getting new articles for feed ${feedUrl.value}`);

        // set feed to be used through entire process
        if (feedUrl.value === null) {
            gettingArticles.value = false;
            console.log(`FeedUrl is undefined`);
            return;
        }
        const currentFeed = feeds[feedUrl.value];
        if (typeof currentFeed === 'undefined') {
            gettingArticles.value = false;
            console.log(`${feedUrl.value} feed not created yet`);
            return;
        }

        const newArticles = await getArticles(currentFeed, currentFeed.latestEtag);
        console.log(`Found ${newArticles.length} new articles`);

        if (window.scrollY > 0) {
            // try to only show once the user has scrolled down enough
            newArticlesAdded.value = newArticles.length;
        }

        const sortedArticles = newArticles.sort((a, b) => {
            if (
                a.info.publicSquare.package.publishDate >
                b.info.publicSquare.package.publishDate
            ) {
                return 1; // use b first
            } else {
                return -1; // use a first
            }
        });

        for (let i = 0; i < sortedArticles.length; i++) {
            let article = sortedArticles[i];

            const valid = await utility.validateArticle(article);

            if (!valid) {
                continue;
            }

            currentFeed.hashes.push(article.infoHash);
            article = await feed.addReplyThread(currentFeed, article);

            // skip if duplicate
            if (currentFeed.duplicateArticles.includes(article.infoHash)) {
                continue;
            }

            const articleTime = article.info.publicSquare.package.publishDate;

            if (currentFeed.articles.at(0).info.publicSquare.package.publishDate < articleTime) {
                // check if article is newer than first
                currentFeed.articles.unshift(article);

                if (feedUrl.value !== currentFeed.feedUrl) {
                    continue;
                }

                // if feed hasn't changed, add new article to thread list
                threads.value.unshift(feed.convertArticleToThread(article));
            } else if (currentFeed.articles.at(-1).info.publicSquare.package.publishDate > articleTime) {
                // check if article is older than last
                currentFeed.articles.push(article);

                if (feedUrl.value !== currentFeed.feedUrl) {
                    continue;
                }

                // if feed hasn't changed, add new article to thread list
                threads.value.push(feed.convertArticleToThread(article));
            } else {
                // place article correctly
                for (let j = 0; j < currentFeed.articles.length; j++) {
                    const present = currentFeed.articles[j];
                    const presentTime = present.info.publicSquare.package.publishDate;

                    if (articleTime > presentTime) {
                        currentFeed.articles.splice(j, 0, article);

                        // if feed hasn't changed, add new article to thread list
                        if (feedUrl.value === currentFeed.feedUrl) {
                            threads.value.splice(j, 0, feed.convertArticleToThread(article));
                        }
                        break;
                    }
                }
            }

            if (i % 10 === 0) {
                // force it to render every 10 elements
                await utility.skipFrame();
            }
        }

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime < spinnerMin) {
            setTimeout(
                () => { gettingArticles.value = false },
                spinnerMin
            )
        } else {
            gettingArticles.value = false
        }
    }

    /**
    * Fetch the Initial Articles for a Feed
    */
    async function makeInitialArticles() {
        if (feedUrl.value === null) {
            console.log(`FeedUrl is undefined`);
            return;
        }

        gettingArticles.value = true;
        const startTime = Date.now();
        console.log(`Getting initial articles for ${feedUrl.value}`);
        console.debug(`${Date.now()} Starting makeInitialArticles`);

        // setup new feed object
        feeds[feedUrl.value] = {
            feedUrl: feedUrl.value,
            latestEtag: '',
            articles: [],
            duplicateArticles: [],
            hashes: [],
            allArticles: []
        }
        // set feed to be used through entire process
        const currentFeed = feeds[feedUrl.value];

        const initialArticles = await getArticles(currentFeed);

        console.log(`Found ${initialArticles.length} initial articles`);
        console.debug(`${Date.now()} Retrieved articles from getArticles`)

        const sortedArticles = initialArticles.sort((a, b) => {
            if (
                a.info.publicSquare.package.publishDate <
                b.info.publicSquare.package.publishDate
            ) {
                return 1; // use b first
            } else {
                return -1; // use a first
            }
        });

        for (let j = 0; j < sortedArticles.length; j++) {
            let article = sortedArticles[j];

            const valid = await utility.validateArticle(article);

            if (!valid) {
                continue;
            }

            currentFeed.hashes.push(article.infoHash);
            article = await feed.addReplyThread(currentFeed, article);

            // skip if duplicate
            if (currentFeed.duplicateArticles.includes(article.infoHash)) {
                continue;
            }

            // add to articles and thread if not a duplicate
            currentFeed.articles.push(article);

            if (feedUrl.value !== currentFeed.feedUrl) {
                continue;
            }

            // if feed hasn't changed, add new article to thread list
            threads.value.push(feed.convertArticleToThread(article));

            if (j % 10 === 0) {
                // force it to render every 10 elements
                await utility.skipFrame();

                // hide the spinner after the first 20
                if (j === 20 && spinnerVisible.value === true) {
                    spinnerVisible.value = false;
                }
            }
        }

        console.debug(`${Date.now()} All valid articles have been added`)

        const elapsedTime = Date.now() - startTime;
        if (elapsedTime < spinnerMin) {
            setTimeout(
                () => { gettingArticles.value = false },
                spinnerMin
            )
        } else {
            gettingArticles.value = false
        }
    }

   /**
    * Switch Feeds to new specified feed
    *
    * @param url Feed URL
    */
    async function switchFeeds(url: string) {
        threads.value = [];
        console.log(`Switched feeds to ${url}`)
        feedUrl.value = url;

        // reset update interval
        clearInterval(updateInterval);
        setInterval(addArticles, 60 * 1000);

        // if undefined feed needs to be created
        const currentFeed = feeds[url];
        if (typeof currentFeed === 'undefined') {
            await makeInitialArticles();
        } else {
            gettingArticles.value = true;
            const startTime = Date.now();
            const articles = currentFeed.articles;
            for (let i = 0; i < articles.length; i++) {
                const article = articles[i];

                if (feedUrl.value !== currentFeed.feedUrl) {
                    // check if feed has changed
                    break;
                }

                // add thread to list
                threads.value.push(feed.convertArticleToThread(article));

                if (i % 10 === 0) {
                    // force it to render every 10 elements
                    await utility.skipFrame();
                }
            }

            const elapsedTime = Date.now() - startTime;
            if (elapsedTime < spinnerMin) {
                setTimeout(
                    () => { gettingArticles.value = false },
                    spinnerMin
                )
            } else {
                gettingArticles.value = false
            }
        }
    }

    // setup add to list functionality
    const lists: Ref<any[]> = ref([]);
    const addList = ref('');
    const editMode = ref(false);
    const showEditBtn = ref(false);

   /**
    * Get All Lists
    */
    async function getLists() {
        const allLists = await getAllLists();
        lists.value = allLists.map(l => 'L | ' + l.name);

        // add in list groups if present
        const listGroups = await getAllListGroups();
        if (listGroups.length > 0) lists.value.push(...listGroups.map(g => 'G | ' + g.name));

        if (lists.value.length > 0) {
            addList.value = lists.value[0];
        }
    }

    function parseEditLink(name: string) {
        if (name?.includes('L | ')) {
            const listName = name.replace(/[LG] \| /, '');
            const listLinkObj = {
                name: 'List',
                params: {
                    listKey: parseListKey(listName)
                }
            }

            return listLinkObj;
        }
        if (name?.includes('G | ')) {
            const groupName = name.replace(/[LG] \| /, '');
            const groupLinkObj = {
                name: 'List Group',
                params: {
                    groupKey: parseListKey(groupName)
                }
            }

            return groupLinkObj;
        }

        return {}
    }

    onMounted(async () => {
        await makeInitialArticles();
        await getLists();

        showEditBtn.value = (lists.value.length > 0 || feedEditKeyName != null);
        updateInterval = setInterval(addArticles, 60 * 1000);
    });

    // enable feed switching
    watch(
        () => props.url,
        (val) => switchFeeds(val)
    );

    // ensure interval doesn't run in the background elsewhere
    onBeforeRouteLeave(() =>
        clearInterval(updateInterval)
    )

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MDBBtn), {
      color: "primary",
      floating: "",
      size: "lg",
      class: _normalizeClass(spinnerVisible.value ? 'loader-div loading' : 'loader-div')
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MDBSpinner))
      ]),
      _: 1
    }, 8, ["class"]),
    (newArticlesAdded.value > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "badge rounded-pill bg-dark p-3 view-new-posts-badge",
          onClick: _cache[0] || (_cache[0] = () => {
            scrollToTop();
            newArticlesAdded.value = 0;
        })
        }, "View " + _toDisplayString(newArticlesAdded.value) + " New Posts", 1))
      : _createCommentVNode("", true),
    (spinnerVisible.value === false && showEditBtn.value && editMode.value === false)
      ? (_openBlock(), _createBlock(_unref(MDBBtn), {
          key: 1,
          color: "primary",
          floating: "",
          size: "lg",
          class: "loader-div loading"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MDBIcon), {
              icon: "edit",
              title: "Add Feed articles to List",
              iconStyle: "fas",
              onClick: _cache[1] || (_cache[1] = () => editMode.value = true)
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "my-2 col-12 col-lg-8",
          onSubmit: _withModifiers(search, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              required: "",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search_term).value = $event)),
              placeholder: "Search For..."
            }, null, 512), [
              [_vModelText, search_term.value]
            ])
          ]),
          _hoisted_6
        ], 40, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads.value, (thread) => {
        return (_openBlock(), _createBlock(ArticleThread, {
          key: 'thread-' + thread[0].infoHash,
          thread: thread,
          editMode: editMode.value,
          addList: addList.value,
          feedUrl: feedUrl.value
        }, null, 8, ["thread", "editMode", "addList", "feedUrl"]))
      }), 128)),
      (threads.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(gettingArticles.value ? 'Loading articles...' : 'No articles available'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (spinnerVisible.value === false && editMode.value)
      ? (_openBlock(), _createBlock(_unref(MDBFooter), {
          key: 2,
          bg: "primary",
          text: ['white', 'center'],
          class: "fixed-bottom p-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (addList.value != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true),
                (addList.value != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        id: "listSelect",
                        class: "form-select",
                        "aria-label": "List to Add Articles to",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addList).value = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (list) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: 'list-' + _unref(parseListKey)(list),
                            value: list
                          }, _toDisplayString(list), 9, _hoisted_16))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, addList.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  (addList.value != '')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: parseEditLink(addList.value),
                        class: "me-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MDBIcon), {
                            icon: "edit",
                            iconStyle: "fas",
                            size: "2x",
                            title: "View and Edit List"
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(MDBIcon), {
                    icon: "times",
                    title: "Stop Editing",
                    iconStyle: "fas",
                    size: "2x",
                    onClick: _cache[4] || (_cache[4] = () => editMode.value = false)
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})